/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { joiResolver } from '@hookform/resolvers/joi';
import { object, func, bool } from 'prop-types';
import mbpLogger from 'mbp-logger';

// MUI
import {
    Grid, Button, CircularProgress,
} from '@material-ui/core';

// Components
import AddMailingAddressForm from '../../AddNewRecipient/AddMailingAddress/AddMailingAddressForm';
import DeleteDialog from '../DeleteDialog';

// Helpers
import { schemaForMailingAddress } from '../../Helpers/Schema';
import { getUserProfile } from '../../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import { getAccessTokenSafely } from '../../../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import { RecipientBookContext } from '../../Context/RecipientBookContext';
import { hasSuggestedAddress } from '../../Helpers/QasHasAddress';
import { contryShort, unmaskPhoneNumber, getIsShowingLocationTypeField } from '../../../Common/Helpers/Helpers';
import RecipientBookBrandColorIcons from '../../Helpers/RecipientBookBrandColorIcons';

// APIs
import { updateSingleAddressEntry } from '../../../../../../../../../apis/account-apis/RecipientBook-apis/updateSingleAddressEntry';
import { deleteSingleAddressEntry } from '../../../../../../../../../apis/account-apis/RecipientBook-apis/deleteSingleAddressEntry';
import { CommonStyles } from '../../../../../../style/commonStyles';
// import StyledButton from '../../../../../../../../components/EnterpriseDesignSystem/Button/StyledButton';

const EditMailingAddress = ({
    classes, address, recipientState, setRecipientState, setCurrentRecipient, setIsAddressEditing, setSelectedAddressToEdit, isParentDesktopComponent,
}) => {
    const useCommonStyles = CommonStyles();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isShowingDeleteDialog, setIsShowingDeleteDialog] = useState(false);

    const userProfile = useSelector(getUserProfile) || {};
    const { ContactId } = userProfile || '';

    const {
        isVerificationNeeded, setIsVerificationNeeded, setConfirmAddress, formatedSelectedAddress, searchResults,
        setSearchResults, setFormatedSelectedAddress, keepAddressClicked, setIsLoadingConfirmation, setKeepAddressClicked, setChooseAddressClicked, currentRecipient
    } = useContext(RecipientBookContext);

    const methods = useForm({ mode: 'all', resolver: joiResolver(schemaForMailingAddress) });
    const hasErrors = !!Object.keys(methods.formState.errors).length > 0;

    const processUpdateMailingAddress = useMutation({
        mutationFn: updateSingleAddressEntry,
        onSuccess: (data) => {
            if (data && data.data !== undefined) {
                const { addressResponse } = data.data;

                // Commenting out below code untill we 100% sure not requrired this code anymore
                // const findUpdatedAddressInState = findRecipientByAddressId(currentRecipient.addressList, addressResponse.addressBookEntryId);
                // if (findUpdatedAddressInState) {
                // Clone the existing recipientState to avoid mutating the original state
                // const updatedRecipientState = [...recipientState.addressBookResponse.addressList];

                // Find the index of the recipient with the matching address
                // const recipientIndex = updatedRecipientState.indexOf(findUpdatedAddressInState);

                // Clone the recipient with the updated address
                // const updatedRecipient = { ...findUpdatedAddressInState };

                // Update the address in the cloned recipient
                const updatedAddresses = currentRecipient.addresses.map((address) => {
                    if (address.defaultKey && address.defaultKey === '1') delete address.defaultKey
                    if (address.addressBookEntryId === addressResponse.addressBookEntryId) {
                        return { ...addressResponse };
                    }
                    return address;
                });
                currentRecipient.addresses = updatedAddresses;

                // Updating current editing recipient which we use on Desktop
                setCurrentRecipient(currentRecipient)
                // Replace the recipient with the updated one in the cloned state - Mobile
                // updatedRecipientState[recipientIndex] = updatedRecipient;

                // Update the state with the new recipientState
                // setRecipientState({ addressBookResponse: { ...recipientState.addressBookResponse, addressList: updatedRecipientState } });
                // }
            }
            setLoading(false);
            setError('');
            setTimeout(() => methods.reset(), 500);
            setSelectedAddressToEdit('');
            setIsAddressEditing(false);
            setIsLoadingConfirmation(false);
            setConfirmAddress(false);
        },
        onError: (err) => {
            setError('Something went wrong. Please try again.');
            setLoading(false);
            setIsLoadingConfirmation(false);
            setConfirmAddress(false);
            mbpLogger.logError({
                function: 'processAddressAndOccasionEntriesMutation',
                appName: process.env.npm_package_name,
                module: 'EditMailingAddress.js',
                message: `Error While Updating an Address for Contact ID: ${userProfile?.ContactId}`,
                err,
            });
        },
    });

    const processDeleteMailingAddressMutation = useMutation({
        mutationFn: deleteSingleAddressEntry,
        onSuccess: (data) => {
            if (data && data.data !== undefined) {
                if (data.status === 200) {
                    const url = data?.config?.url || '';
                    const parts = url.split('/');
                    const addressBookEntryId = parts?.[parts?.length - 1];
                    const updatedData = currentRecipient.addresses.filter((addr) => addr.addressBookEntryId !== addressBookEntryId);
                    currentRecipient.addresses = updatedData;
                    setCurrentRecipient(currentRecipient);

                    // Commenting out below code untill we 100% sure not requrired this code anymore
                    // const updateRecipient = [...recipientState.addressBookResponse.addressList];
                    // const findIndex = updateRecipient.findIndex((res) => res.addresses.find((addr) => addr.addressBookEntryId === addressBookEntryId));
                    // const updatedData = updateRecipient[findIndex].addresses.filter((addr) => addr.addressBookEntryId !== addressBookEntryId);
                    // updateRecipient[findIndex].addresses = updatedData;
                    // setRecipientState({ addressBookResponse: { ...recipientState.addressBookResponse, addressList: updateRecipient } });

                }
            }
            setLoading(false);
            setIsLoadingConfirmation(false);
            setConfirmAddress(false);
            setError('');
            setIsAddressEditing(false);
        },
        onError: (err) => {
            setError('Something went wrong. Please try again.');
            setLoading(false);
            setIsLoadingConfirmation(false);
            setConfirmAddress(false);
            mbpLogger.logError({
                function: 'processDeleteMailingAddressMutation',
                appName: process.env.npm_package_name,
                module: 'EditMailingAddress.js',
                message: `Error While Deleting an Address ID ${address?.addressBookEntryId} for Recipient with Contact ID: ${userProfile?.ContactId}`,
                err,
            });
        },
    });

    const updateMailingAddress = async (payload) => {
        setLoading(true);
        const jwtToken = await getAccessTokenSafely();
        const addressBookEntryId = address.addressBookEntryId;
        processUpdateMailingAddress.mutate({
            ContactId,
            addressBookEntryId,
            data: payload,
            jwtToken,
        });
    };

    const deleteMailingAddress = async () => {
        setLoading(true);
        const jwtToken = await getAccessTokenSafely();
        processDeleteMailingAddressMutation.mutate({ ContactId, addressBookEntryId: address.addressBookEntryId, jwtToken });
    };

    useEffect(() => {
        // clear QAS state on unmount
        return () => {
            setIsVerificationNeeded(false);
            setConfirmAddress(false);
            setSearchResults([])
            setFormatedSelectedAddress({});
            setKeepAddressClicked(false);
            setChooseAddressClicked(false);
        }
    }, []);

    useEffect(() => {
        if (keepAddressClicked && !isVerificationNeeded) {
            methods.handleSubmit(onSaveSubmit)();
        }
    }, [keepAddressClicked, isVerificationNeeded]);

    const handleOnSubmit = (data) => {
        const unmaskedPhoneNumber = data.phoneNumber ? unmaskPhoneNumber(data.phoneNumber) : '';
        const editCurrentAddressPayload = {
            ...address,
            ...data,
            rcpEmployerName: currentRecipient?.rcpEmployerName || '',
            firstName: !currentRecipient?.rcpFirstName && currentRecipient?.rcpEmployerName ? currentRecipient.rcpEmployerName : currentRecipient.rcpFirstName,
            lastName: !currentRecipient?.rcpLastName && currentRecipient?.rcpEmployerName ? currentRecipient.rcpEmployerName : currentRecipient.rcpLastName,
            defaultKey: data.defaultKey || address.defaultKey ? '1' : '0',
            createdUser: "SSP",
            country: data.country ? contryShort[data.country] : '',
            phoneNumber: unmaskedPhoneNumber,
            employerName: data.employerName && getIsShowingLocationTypeField(data.addressType) ? data.employerName : '',
        };
        updateMailingAddress(editCurrentAddressPayload);
    };

    const onSaveSubmit = (data) => {
        if (address.defaultKey === '1') data.defaultKey = '1'; // Add default key to the data if the default address is enabled for current address
        if (isVerificationNeeded) {
            const hasAddress = hasSuggestedAddress({ formatedSelectedAddress, methods, searchResults });
            if (hasAddress) {
                setIsVerificationNeeded(false);
                return handleOnSubmit(data); // do not remove this return stetment
            } else {
                return setConfirmAddress(true); // do not remove this return stetment
            }
        }
        handleOnSubmit(data);
    };

    return (
        <div key={address.addressBookEntryId}>
            <div className="addMailingFormContainer">
                <form>
                    <AddMailingAddressForm methods={methods} classes={classes} address={address} isViewingEditForm />
                    {error && (
                        <Grid container justifyContent="center" alignItems="center" className={useCommonStyles.marginBottom10}>
                            <p className={useCommonStyles.errorContainer}>{error}</p>
                        </Grid>
                    )}
                    <Grid container direction="row" justifyContent="center" alignItems="center" className={useCommonStyles.marginTopB}>
                        <Grid container item xs={12} md={5} lg={5} justifyContent="center" alignItems="center">
                            <Grid item xs={2} md={2} lg={2}>
                                <Button className={classes.deleteBtnIcon} onClick={() => setIsShowingDeleteDialog(true)}>
                                    <RecipientBookBrandColorIcons className={classes.deleteIcon} strockClass={classes.deleteIconStroke} icon='DeleteIcon' />
                                </Button>
                                <DeleteDialog
                                    classes={classes}
                                    loading={loading}
                                    error={error}
                                    isShowingDeleteDialog={isShowingDeleteDialog}
                                    setIsShowingDeleteDialog={setIsShowingDeleteDialog}
                                    handleClick={deleteMailingAddress}
                                    description="Address"
                                />
                            </Grid>
                            <Grid item xs={10} md={8} lg={8}>
                                <Button
                                    fullWidth
                                    variant='contained'
                                    className={classes.commonBtnContained}
                                    onClick={methods.handleSubmit(onSaveSubmit)}
                                    disabled={loading || hasErrors}
                                    style={isParentDesktopComponent ? { width: '244px', height: '46px', margin: '0px 0px 0px 24px', float: 'none' } : { width: '100%', height: '46px' }}
                                >
                                    {loading ? <CircularProgress /> : 'Save'}
                                </Button>
                                {
                                    /*
                                    This EDS button styles are being overriden by the button styles inside main.js
                                    
                                    We should figure out what is protecting other buttons from inheriting the styles inside main.js but this button
                                    is not protected. Disabling this button for now.
                                    */
                                }
                                {/* <StyledButton
                                        fullWidth
                                        variant="primary"
                                        handleOnClick={methods.handleSubmit(onSubmit, onError)}
                                        disabled={loading || isDisable}
                                        label={loading ? <CircularProgress /> : 'Save'}
                                        size={'md'}
                                        type="submit"
                                    /> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </div>
    );
};

EditMailingAddress.propTypes = {
    recipientState: object.isRequired,
    setRecipientState: func.isRequired,
    setCurrentRecipient: func.isRequired,
    setIsAddressEditing: func.isRequired,
    setSelectedAddressToEdit: func.isRequired,
    isParentDesktopComponent: bool.isRequired,
    address: object.isRequired,
    classes: object.isRequired,
};

export default EditMailingAddress;
